// extracted by mini-css-extract-plugin
export default {"container":"styles_container__d986j","title":"styles_title__oTGN5"};